module.exports = __webpack_public_path__ + "static/img/mp3.c5a0b9c4.png";